// ============================================================
// 生态数据 Vuex 模块
// 存放四大生态静态数据、痛点、目标人群、FAQ 等
// ============================================================
import {
  ecosystems, locks, personas, steps, faqs,
  serviceOrders, solutionItems, supplyProjects,
  registerCopyByEco
} from '@/constants/ecosystemData';

export default {
  namespaced: true,
  state: {
    ecosystems,
    locks,
    personas,
    steps,
    faqs,
    serviceOrders,
    solutionItems,
    supplyProjects,
    registerCopyByEco
  },
  getters: {
    ecosystemBySlug: (state) => (slug) => {
      return state.ecosystems.find(e => e.slug === slug) || null;
    },
    otherEcosystems: (state) => (slug) => {
      return state.ecosystems.filter(e => e.slug !== slug);
    },
    serviceOrdersFiltered: (state) => (filter) => {
      if (!filter || filter === '全部') return state.serviceOrders;
      return state.serviceOrders.filter(o => o.type === filter);
    },
    supplyProjectsFiltered: (state) => (filter) => {
      if (!filter || filter === '全部') return state.supplyProjects;
      return state.supplyProjects.filter(p => p.cat === filter);
    }
  }
};
